import i18next from 'i18next';
import { CmsFilters } from 'js/model/cms/cms-browse-page';
import { VenueListingSpecificationOutput } from 'js/model/rainbow/browse-page/VenueListingSpecificationOutput';

export const isSalonsFilterActive = (selectedSalons: string[]): boolean =>
  selectedSalons.length > 0;

export const getTopRatedAccoladeId = (cmsFilters: CmsFilters): number =>
  parseInt(cmsFilters['top-rated-accolade-id'], 10);

export const isTopRatedSalonSelected = (
  { accolade }: VenueListingSpecificationOutput,
  topRatedAccoladeId: number
): boolean => accolade?.id === topRatedAccoladeId ?? false;

export const getSelectedSalons = (
  specification: VenueListingSpecificationOutput,
  cmsFilters: CmsFilters
): string[] => {
  const selectedSalons = [];
  const topRatedAccoladeId = getTopRatedAccoladeId(cmsFilters);
  const isTopRated = isTopRatedSalonSelected(specification, topRatedAccoladeId);

  if (isTopRated) {
    selectedSalons.push(cmsFilters['top-rated-venues']);
  }

  if (specification.newVenues) {
    selectedSalons.push(i18next.t('browsePage.filter.salons.newVenues.title'));
  }

  return selectedSalons;
};
